"use client";

import { motion, useReducedMotion } from "@/lib/motion";
import { EyebrowBadge } from "@/components/ui/eyebrow-badge";
import { HeroGlow } from "@/components/ui";
import { EMAIL } from "@/lib/constants";

export default function PartnersSection() {
  const prefersReducedMotion = useReducedMotion();

  return (
    <section
      className="border-border relative overflow-y-clip border-b pt-32 pb-28 lg:pt-40 lg:pb-36"
      aria-labelledby="partners-heading"
    >
      <HeroGlow align="center" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={prefersReducedMotion ? false : { opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="flex flex-col items-center text-center"
        >
          <motion.div
            initial={prefersReducedMotion ? false : { opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.4 }}
          >
            <EyebrowBadge>Partner Program</EyebrowBadge>
          </motion.div>

          <h1
            id="partners-heading"
            className="text-foreground mb-5 max-w-3xl text-4xl leading-[1.1] font-bold tracking-tight sm:text-5xl lg:text-6xl"
          >
            The Partner Program is closed until further notice
          </h1>

          <p className="text-muted-foreground mb-2 max-w-xl text-lg leading-relaxed">
            We&apos;re not accepting new partner, reseller, or integration applications at this
            time. Check back here for updates on when the program reopens.
          </p>

          <p className="text-muted-foreground text-sm">
            Questions? Reach out to{" "}
            <a href={`mailto:${EMAIL.support}`} className="text-foreground underline">
              {EMAIL.support}
            </a>
            .
          </p>
        </motion.div>
      </div>
    </section>
  );
}
